import { finish, error } from '../../../modules/user/actions/change-email';

import api from '../../../api';

export function request(dispatch, action) {
    api.post('/user/change-email', {
        email: action.email,
        old: action.old
    }).then(
        ({ data }) => dispatch(finish(data)),
        ({ errors }) => dispatch(error(errors))
    );
}
